import { render, staticRenderFns } from "./ChooseRestrauntsModal.vue?vue&type=template&id=6e5f3762&scoped=true&"
import script from "./ChooseRestrauntsModal.vue?vue&type=script&lang=js&"
export * from "./ChooseRestrauntsModal.vue?vue&type=script&lang=js&"
import style0 from "./ChooseRestrauntsModal.vue?vue&type=style&index=0&id=6e5f3762&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e5f3762",
  null
  
)

export default component.exports